<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="actPdfMain">
          <project-asset
            v-on:project-changed="onProjectChange"
            v-on:vessel-changed="onVesselChange"
          ></project-asset>
          <v-card id="actPdfCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.pdfConf') }}</v-card-title
            >
            <v-data-table
              id="actPdfTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">
                    {{ $t(props.item.columnDescription) }}
                  </td>
                  <td style="text-align: center">
                    <v-checkbox v-model="props.item.visible" @change="hndStateChange(props.item)"></v-checkbox>
                  </td>

                  <td style="text-align: left">
                    {{ props.item.projectName }}
                  </td>
                  <td style="text-align: left">
                    {{ props.item.vesselName }}
                  </td>
                </tr>
              </template>
            </v-data-table>

          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ProjectAsset from '../common/ProjectAsset'

export default {
  components: {
    'project-asset': ProjectAsset
  },
  data() {
    return {
      dialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('common.column'),
          align: 'left',
          value: 'columnDescription'
        },
        { text: this.$t('column.visible'), align: 'center', value: 'visible' },
        {
          text: this.$t('common.projectName'),
          align: 'left',
          value: 'projectId'
        },
        {
          text: this.$t('common.asset'),
          align: 'left',
          value: 'vesselId'
        }
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: {},

      maxCode: '',
      selProjectId: null,
      selVesselId: null,
      dlgSelProjectId: null
    }
  },
  computed: {
    ...mapGetters([
      'getMaxCode',

      'm_project/getProjectNames',
      'm_vessel/getVesselNames',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',

      'm_pdfCfg/getPdfConfigurations'
    ]),

    projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },

    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.pdfConf')
        : this.$t('common.edit') + ' ' + this.$t('nav.pdfConf')
    },

    items() {
      return this['m_pdfCfg/getPdfConfigurations']
    },
    
    formIsValid() {
      return this.editedItem.columnDescription
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']

    this.$log.debug('load pdf configurations', this.selProjectId, this.selVesselId)

    this['m_pdfCfg/fetchConfigurations']({
      pId: this.selProjectId,
      vId: this.selVesselId
    })
  },
  methods: {
    ...mapMutations(['mHideLongLoader']),
    ...mapActions([
      'm_pdfCfg/fetchConfigurations',
      'm_pdfCfg/updateConfiguration',
      'm_pdfCfg/toggleConfiguration'
    ]),

    refreshConfigurations() {
      this['m_pdfCfg/fetchConfigurations']({
        pId: this.selProjectId,
        vId: this.selVesselId
      })
    },

    onProjectChange(value) {
      this.selProjectId = value
      this.refreshConfigurations()
    },

    onVesselChange(value) {
      this.selVesselId = value
      this.refreshConfigurations()
    },

    hndStateChange(item) {
      this.$log.debug('column', item.columnDescription, 'state change: visible?', item.visible);
      this['m_pdfCfg/toggleConfiguration'](item);
    },

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.dialog = true
    },

    close() {
      this.dialog = false
      this.resetEntity()
    },

    save() {
      this['m_pdfCfg/updateConfiguration'](this.editedItem).then(() =>
        this.refreshConfigurations()
      )
      this.close()
    }
  }
}
</script>

<style>
#actPdfTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#actPdfTable header {
  font-weight: bold;
}
#actPdfCard {
  width: auto;
}
</style>
